import {all, fork} from 'redux-saga/effects';
import provideKeycloakTokenToServicesFlow from './sagas/provideKeycloakTokenToServicesFlow';
import provideArcGISTokenToServicesFlow from './sagas/provideArcGISTokenToServicesFlow';
import config from '../config';

const applicationWatcher = function* applicationWatcher() {
    yield all([
        fork(provideKeycloakTokenToServicesFlow),
        ...(!config.IS_FALLBACK_SYSTEM ? [fork(provideArcGISTokenToServicesFlow)] : []),
    ]);
};

export default applicationWatcher;
